export default __webpack_public_path__ + "static/media/online_guide_for_programming_exercise.7f80a6f6.zip";